<template>
  <div>
  <h2 class="my-2">Active Service Requests for {{this.memberInfo.name}}</h2>
  <v-data-table
      :loading="isLoading"
      disable-sort
      class="elevation-2"
      loading-text="Loading... Please Wait"
      hide-default-footer
      :headers="activeRequestsTableHeaders"
      :items="activeServiceRequests"
      no-data-text="No Service Requests to Display">

    <template v-slot:item.timestamp="{ item }">
      {{ formatTimestamp(item.timestamp) }}
    </template>

    <template v-slot:item.updated_at="{ item }">
      {{ formatTimestamp(item.lastUpdated) }}
    </template>

    <template v-slot:item.notes="{ item }">
      <div v-if="item.notes && item.notes.length">
        <div v-for="(note, index) in item.notes" :key="index" class="mb-1">
          {{ note.note }}
        </div>
      </div>
      <span v-else class="text--disabled">No notes</span>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip small>
        {{ item.latestStatus }}
      </v-chip>
    </template>

    <template v-slot:item.fromAmount="{ item }">
      <span v-if="item.fromAssetId" :style="{color: assetColor(item.fromAssetId)}">
        -{{ item.fromAmount }}
      </span>
      <br v-if="item.fromAssetId && item.toAssetId"/>
      <span v-if="item.toAmount" :style="{color: assetColor(item.toAssetId)}">
        {{ item.toAmount }}
      </span>
    </template>

    <template v-slot:item.fromAsset="{ item }">
      <span :style="{color: assetColor(item.fromAssetId)}">
        {{ item.fromAsset }}
      </span>
      <br v-if="item.fromAsset && item.toAsset"/>
      <span :style="{color: assetColor(item.toAsset)}">
        {{ item.toAsset }}
      </span>
    </template>

    <template v-slot:item.new_tab ="{ item }">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon @click="rowClick(item.uuid)">mdi-tab-plus</v-icon>
          </v-btn>
        </template>
        <span>Open Task in a New Tab</span>
      </v-tooltip>
    </template>
  </v-data-table>
  </div>
</template>

<script>
import {format} from "date-fns";

export default {
  name: "ActiveUserRequests",
  props: {
    memberInfo: {
      type: Object,
      required: true,
      validator(value) {
        return !!value.email;
      }
    },
  },

  data: () => ({
    isLoading: false,
    activeServiceRequests: [],
    activeRequestsTableHeaders: [
      {value: 'timestamp', text: 'Created'},
      {value: 'updated_at', text: 'Last Updated'},
      {value: 'actionableOn', text: 'Actionable On'},
      {value: 'type', text: 'Type'},
      {value: 'status',  text: 'Status'},
      {value: 'fromAmount', text: 'Amounts', align: 'end'},
      {value: 'fromAsset', text: 'Assets', align: 'start'},
      {value: 'orderId',  text: 'Order #'},
      {value: 'new_tab',  text: ''},
    ]
  }),

  watch: {
    'memberInfo.email': {
      immediate: true,
      handler(newEmail) {
        this.fetchRecentServiceRequests(newEmail);
      }
    }
  },

  methods: {
    async fetchRecentServiceRequests(email) {
      this.isLoading = true;
      const response = await this.$axios.get(`/admin/service/requestsByUser`, {
        params: {username: email}
      });
      this.activeServiceRequests = response.data;
      this.isLoading = false;
    },

    rowClick: function (uuid) {
      window.open('/tasks/' + uuid, '_blank');
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return null;
      return format(new Date(timestamp), 'MMMM dd, yyyy hh:mm a');
    },
  },

};
</script>